<template>
  <thead>
    <tr>
      <th
        v-for='(item, i) in header'
        :key='i'
        :class='[
          `text-${getAlignment(item.align)}`,
          {"cursor-pointer": item.sortable}
        ]'
        @click='() => {
          if (item.sortable) {
            $emit("clickHeaderItem", item)
          }
        }'
      >
        <div v-if='item.value === "selected" && $getRight("categoryCreate") && $getRight("itemEdit")'>
          <v-simple-checkbox
            color='#9e9bd2'
            v-model='selectAllComputed'
          />
        </div>
        <div v-else class='inventory_headerItem text-no-wrap'>
          <span
            :style='{
              color: computedSortColor(item)
            }'
          >{{ item.text }}</span>
          <v-icon
            v-if='item.sortable'
            size='16'
            :style='{
              "opacity": item.sortState.active ? 1 : 0.5
            }'
            :color='computedSortColor(item)'
            class='inventory_headerItem_icon'
          >
            {{ computedSortIcon(item) }}
          </v-icon>
        </div>
      </th>
    </tr>
  </thead>
</template>

<script>
const sortResolver = item => {
  if (item.sortState) {
    const state = item.sortState
    if (!state.active) return 0
    if (state.order === 'desc') return -1
    return 1
  }
  return null
}
export default {
  props: {
    header: {
      type: Array,
      required: true
    },
    selectAll: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    computedSortIcon() {
      return item => {
        if (sortResolver(item) !== null) {
          if (sortResolver(item) === 0) return 'mdi-sort-alphabetical-variant'
          if (sortResolver(item) === -1) return 'mdi-sort-alphabetical-descending'
          return 'mdi-sort-alphabetical-ascending'
        } return 'mdi-sort-alphabetical-variant'
      }
    },
    computedSortColor() {
      return item => {
        if (sortResolver(item) !== null) {
          if (sortResolver(item) === 0) return '#43425d'
          return '#7972c0'
        }
        return '#43425d'
      }
    },
    selectAllComputed: {
      get() {
        return this.selectAll
      },
      set(v) {
        this.$emit('changeSelectAll', v)
      }
    },
    getAlignment() {
      const variants = {
        start: 'left',
        center: 'center',
        end: 'end'
      }
      return v => variants[v]
    }
  }
}
</script>

<style scoped lang="scss">
  .inventory_headerItem_icon {
    transition: 0.2s linear;
  }
</style>
